import { lazy, Suspense } from "react";
import { Outlet } from "react-router-dom";
import { AuthGuard } from "src/auth/guard";
import { LoadingScreen } from "src/components/loading-screen";
import DefaultLayout from "src/layouts/default";
import { paths } from "src/routes/paths";

// ----------------------------------------------------------------------

const UsersListPage = lazy(() => import("src/pages/users/list"));
const SuspendAppPage = lazy(() => import("src/pages/operations/suspend-app"));
const UpdateNotificationPage = lazy(
  () => import("src/pages/operations/update-notification"),
);
const TermsReconsentPage = lazy(
  () => import("src/pages/operations/terms-reconsent"),
);
const MunicipalityDataPage = lazy(
  () => import("src/pages/operations/municipality-data"),
);

// ----------------------------------------------------------------------

export const operationsRoutes = [
  {
    element: (
      <AuthGuard>
        <DefaultLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DefaultLayout>
      </AuthGuard>
    ),
    children: [
      {
        path: paths.operations.root,
        element: <UsersListPage />,
      },
      {
        path: paths.operations.detail.suspendApp,
        element: <SuspendAppPage />,
      },
      {
        path: paths.operations.detail.updateNotification,
        element: <UpdateNotificationPage />,
      },
      {
        path: paths.operations.detail.termsReconsent,
        element: <TermsReconsentPage />,
      },
      {
        path: paths.operations.detail.municipalityData,
        element: <MunicipalityDataPage />,
      },
    ],
  },
];
